export const PASS_HREF = true
export const LEGACY_BEHAVIOR = true
export const ROOT_ELEMENT = 'A'
